import React, {Component} from "react";
import {Route, Switch} from "react-router-dom";
import {connect} from "react-redux";
import {createTheme, MuiThemeProvider, withStyles,} from "@material-ui/core/styles";
import {getCurrentUserMindfiles, getMindfile, getUserViewOpts} from "./state/actions/getDataActions";
import "./App.css";
import Dialog from "@material-ui/core/Dialog";
import Box from "@material-ui/core/Box";
import Explore from "./components/pages/explore/Explore";
import Avatar from "./components/pages/avatar/Avatar";
import Social from "./components/pages/social/Social";
import Spacecast from "./components/pages/spacecast/Spacecast";
import Admin from "./components/pages/admin/Admin";
import Settings from "./components/pages/settings/Settings";
import ContributorSettings from "./components/pages/settings/ContributorSettings";
import Logout from "./components/pages/logout/Logout";
import Header from "./components/organisms/header/Header";
import RightDrawer from "./components/organisms/drawer/right-drawer/RightDrawer";
import Loader from "./components/organisms/loader/Loader";
import rawTheme from "./theme.json";
import ContactDialog from "./components/organisms/dialogs/ContactDialog";
import ErrorBoundary from "./components/util/common/ErrorBoundary";
import HelpPage from "./components/organisms/help/HelpPage";

const theme = createTheme({
  ...rawTheme,
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "0.85em",
      },
    },
    MuiInputLabel: {
      outlined:{
        transform: "translate(14px, 12px) scale(1)"
      }
    }
  }
});

const drawerWidth = 280;
const styles = theme => ({
  main: {
    width: "100%",
    display: 'flex',
    flexDirection: 'column',
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  mainLeftShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
  header: {
    zIndex: 10,
  },
});

class App extends Component {
  state = {
    isRightDrawerOpen: false,
    isContactDialogOpen: false,
    isHelpDialogOpen: false,
  };

  toggleRightDrawer = () => {
    this.setState(state => ({ isRightDrawerOpen: !state.isRightDrawerOpen }));
  };

  openHelpDialog() {
    this.setState({ isHelpDialogOpen: true });
  }

  closeHelpDialog() {
    this.setState({ isHelpDialogOpen: false });
  }

  openContactDialog() {
    this.setState({ isContactDialogOpen: true });
  }

  closeContactDialog() {
    this.setState({ isContactDialogOpen: false });
  }

  componentDidMount() {
    if (!this.props.mindfile || !this.props.mindfile.id) {
      this.props.getMindfile(this.props.user.mid);
      this.props.getCurrentUserMindfiles();
      this.props.getUserViewOpts(this.props.user.mid);
    }else{
      this.props.getUserViewOpts(this.props.mindfile.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const mid = !!this.props.mindfile && !!this.props.mindfile.id ? this.props.mindfile.id : null;
    const prevMid = !!prevProps.mindfile && !!prevProps.mindfile.id ?prevProps.mindfile.id : null;
    if (mid !== prevMid) {
      this.props.getUserViewOpts(this.props.mindfile.id);
    }
  }

  isContributor() {
    if (this.props.mindfile && this.props.mindfile.contributors) {
      const contributors = this.props.mindfile.contributors;
      const user = this.props.user;
      if (contributors.find(contributor => contributor.id === user.uid)) {
        if (user.mid !== this.props.mindfile.id) {
          return true;
        }
      }
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <ErrorBoundary>
          {!!this.props.mindfile && !!this.props.mindfile.id
            ?

              <div className="app" id="app" key={this.props.mindfile.id}>
                <RightDrawer
                  isRightDrawerOpen={this.state.isRightDrawerOpen}
                  toggleRightDrawer={this.toggleRightDrawer}
                  openContactDialog={this.openContactDialog.bind(this)}
                  openHelpDialog={this.openHelpDialog.bind(this)}
                  drawerWidth={drawerWidth}
                />
                <main className={classes.main}>
                  <Header
                    classes={{ root: classes.header }}
                    isRightDrawerOpen={this.state.isRightDrawerOpen}
                    toggleRightDrawer={this.toggleRightDrawer}
                    openContactDialog={this.openContactDialog.bind(this)}
                    openHelpDialog={this.openHelpDialog.bind(this)}
                  />
                  <div id="appContent" style={{height:'100%'}}>
                      <Switch>
                        <Route exact path="/" component={Explore} />
                        <Route path="/explore" component={Explore} />
                        {/*<Route path="/profile" component={Profile} />*/}
                        <Route path="/avatar" component={Avatar} />
                        <Route path="/social" component={Social} />
                        <Route path="/spacecast" component={Spacecast} />
                        {this.props.user.is_admin ? (
                          <Route path="/admin" component={Admin} />
                        ) : null}
                        {this.props.mindfile.owner === this.props.user.uid ? (
                          <Route path="/settings" component={Settings} />
                        ) : null}{" "}
                        {this.isContributor() ? (
                          <Route path="/contributor-settings" component={ContributorSettings} />
                        ) : null}{" "}
                        <Route path="/logout" component={Logout} />
                      </Switch>
                  </div>
                </main>
              </div>
          : null }
          <Dialog open={!this.props.mindfile || !this.props.mindfile.id || !!this.props.mindfile.loading}>
            <Box p={3} minWidth={300}>
              <Loader id="mindfileLoader" text="Loading Mindfile" />
            </Box>
          </Dialog>
          <ContactDialog
            isOpen={this.state.isContactDialogOpen}
            closeDialog={this.closeContactDialog.bind(this)}
          />
          <HelpPage variant="dialog"
            isOpen={this.state.isHelpDialogOpen}
            setOpen={open => this.setState({ isHelpDialogOpen: open })}
          />
        </ErrorBoundary>
      </MuiThemeProvider>
    );
  }
}

const styledApp = withStyles(styles)(App);

const mapStateToProps = state => {
  return {
    mindfile: state.mindfile,
    user: state.auth,
    userViewOpts: state.userViewOpts
  };
};

const mapDispatchToProps = {
  getMindfile,
  getCurrentUserMindfiles,
  getUserViewOpts
};

const connectedApp = connect(mapStateToProps, mapDispatchToProps)(styledApp);

export default connectedApp;
